export class OrderQuotaToDetachedInput {
  id?: number;
  quota?: number;
  orderId?: number;
  customerId?: number;

}
